export default "__VITE_ASSET__3a1e62f2__"